import React, { useState } from 'react';
import { Glossary } from "../../Glossary";

export const BackgroundInfo = (props) => {
    const { charBackground } = props;
    const [selectedKeyword, setSelectedKeyword] = useState(null);

    const openGlossary = (keyword) => {
        setSelectedKeyword(keyword);
    };

    const closeGlossary = () => {
        setSelectedKeyword(null);
    };

    const renderBackground = () => {
        switch (charBackground) {
            case "Acolyte":
                return <AcolyteInfo />;
            case "Artisan":
                return <ArtisanInfo />;
            case "Charlatan":
                return <CharlatanInfo />;
            case "Criminal":
                return <CriminalInfo />;
            case "Entertainer":
                return <EntertainerInfo />;
            case "Farmer":
                return <FarmerInfo />;
            case "Guard":
                return <GuardInfo />;
            case "Guide":
                return <GuideInfo />;
            case "Hermit":
                return <HermitInfo />;
            case "Merchant":
                return <MerchantInfo />;
            case "Noble":
                return <NobleInfo />;
            case "Sage":
                return <SageInfo />;
            case "Sailor":
                return <SailorInfo />;
            case "Scribe":
                return <ScribeInfo />;
            case "Soldier":
                return <SoldierInfo />;
            case "Wayfarer":
                return <WayfarerInfo />;
            default:
                return (
                    <div className="select-species-prompt">
                        Select a background 
                        <span className="animated-arrow"> {">"} {">"} {">"} </span>
                    </div>
                );
        }
    };

    const AcolyteInfo = () => {
        return (
            <>
                <h3>Acolyte</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Intelligence, Wisdom, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('MagicInitiate')}
                                >
                                    Magic Initiate (Cleric)
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Insight and Religion</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Calligrapher’s Supplies</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Calligrapher’s Supplies, Book (prayers), Holy Symbol, Parchment (10 sheets), Robe, and 8 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Acolyte" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const ArtisanInfo = () => {
        return (
            <>
                <h3>Artisan</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Dexterity, Intelligence</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Crafter')}
                                >
                                    Crafter
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Investigation and Persuasion</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Choose one kind of Artisan’s Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Artisan’s Tools (same as above), 2 Pouches, Traveler’s Clothes, and 32 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Artisan" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const CharlatanInfo = () => {
        return (
            <>
                <h3>Charlatan</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Dexterity, Constitution, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Skilled')}
                                >
                                    Skilled
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Deception and Sleight of Hand</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Forged Kit</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Forgery Kit, Costume, Fine Clothes, and 15 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Charlatan" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const CriminalInfo = () => {
        return (
            <>
                <h3>Criminal</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Dexterity, Constitution, Intelligence</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Alert')}
                                >
                                    Alert
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Sleight of Hand and Stealth</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Thieves’ Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) 2 Daggers, Thieves’ Tools, Crowbar, 2 Pouches, Traveler’s Clothes, and 16 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Criminal" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const EntertainerInfo = () => {
        return (
            <>
                <h3>Entertainer</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Dexterity, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Musician')}
                                >
                                    Musician
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Acrobatics and Performance</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Choose one kind of Musical Instrument</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Musical Instrument (same as above), 2 Costumes, Mirror, Perfume, Traveler’s Clothes, and 11 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Entertainer" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const FarmerInfo = () => {
        return (
            <>
                <h3>Farmer</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Constitution, Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Tough')}
                                >
                                    Tough
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Animal Handling and Nature</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Carpenter’s Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Sickle, Carpenter’s Tools, Healer’s Kit, Iron Pot, Shovel, Traveler’s Clothes, and 30 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Farmer" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const GuardInfo = () => {
        return (
            <>
                <h3>Guard</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Intelligence, Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Alert')}
                                >
                                    Alert
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Athletics and Perception</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Choose one kind of Gaming Set</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Spear, Light Crossbow, 20 Bolts, Gaming Set (same as above), Hooded Lantern, Manacles, Quiver, Traveler’s Clothes, and 12 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Guard" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const GuideInfo = () => {
        return (
            <>
                <h3>Guide</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Dexterity, Constitution, Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('MagicInitiate')}
                                >
                                    Magic Initiate (Druid)
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Stealth and Survival</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Cartographer’s Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Shortbow, 20 Arrows, Cartographer’s Tools, Bedroll, Quiver, Tent, Traveler’s Clothes, and 3 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Guide" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const HermitInfo = () => {
        return (
            <>
                <h3>Hermit</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Constitution, Wisdom, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Healer')}
                                >
                                    Healer
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Medicine and Religion</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Herbalism Kit</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Quarterstaff, Herbalism Kit, Bedroll, Book (philosophy), Lamp, Oil (3 flasks), Traveler’s Clothes, and 16 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Hermit" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const MerchantInfo = () => {
        return (
            <>
                <h3>Merchant</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Constitution, Intelligence, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Lucky')}
                                >
                                    Lucky
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Animal Handling and Persuasion</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Navigator’s Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Navigator’s Tools, 2 Pouches, Traveler’s Clothes, and 22 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Merchant" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
                {selectedKeyword && (
                    <Glossary keyword={selectedKeyword} onClose={closeGlossary} />
                )}
            </>
        );
    };

    const NobleInfo = () => {
        return (
            <>
                <h3>Noble</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Intelligence, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Skilled')}
                                >
                                    Skilled
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>History and Persuasion</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Choose one kind of Gaming Set</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Gaming Set (same as above), Fine Clothes, Perfume, and 29 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Noble" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const SageInfo = () => {
        return (
            <>
                <h3>Sage</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Constitution, Intelligence, Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('MagicInitiate')}
                                >
                                    Magic Initiate (Wizard)
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Arcana and History</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Calligrapher’s Supplies</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Quarterstaff, Calligrapher’s Supplies, Book (history), Parchment (8 sheets), Robe, and 8 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Sage" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const SailorInfo = () => {
        return (
            <>
                <h3>Sailor</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Dexterity, Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('TavernBrawler')}
                                >
                                    Tavern Brawler
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Acrobatics and Perception</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Navigator’s Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Dagger, Navigator’s Tools, Rope, Traveler’s Clothes, and 20 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Sailor" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const ScribeInfo = () => {
        return (
            <>
                <h3>Scribe</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Dexterity, Intelligence, Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Skilled')}
                                >
                                    Skilled
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Investigation and Perception</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Calligrapher’s Supplies</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Calligrapher’s Supplies, Fine Clothes, Lamp, Oil (3 flasks), Parchment (12 sheets), and 23 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Scribe" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const SoldierInfo = () => {
        return (
            <>
                <h3>Soldier</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Strength, Dexterity, Constitution</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('SavageAttacker')}
                                >
                                    Savage Attacker
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Athletics and Intimidation</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Choose one kind of Gaming Set</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Spear, Shortbow, 20 Arrows, Gaming Set (same as above), Healer’s Kit, Quiver, Traveler’s Clothes, and 14 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Soldier" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const WayfarerInfo = () => {
        return (
            <>
                <h3>Wayfarer</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Ability Scores</td>
                            <td style={{ padding: '8px' }}>Dexterity, Wisdom, Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Feat</td>
                            <td style={{ padding: '8px' }}>
                                <button
                                    className="glossary-link"
                                    onClick={() => openGlossary('Lucky')}
                                >
                                    Lucky
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Insight and Stealth</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiency</td>
                            <td style={{ padding: '8px' }}>Thieves’ Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) 2 Daggers, Thieves’ Tools, Gaming Set (any), Bedroll, 2 Pouches, Traveler’s Clothes, and 16 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Wayfarer" 
                        className="link" 
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    return (
        <>
            {renderBackground()}
            {selectedKeyword && (
                <Glossary keyword={selectedKeyword} onClose={closeGlossary} />
            )}
        </>
    );
};
